var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ansi-layers-root" }, [
    _c("div", { staticClass: "card menu-bg-blue-transparent dll-container" }, [
      _vm.isUshrUser && _vm.customerName
        ? _c(
            "div",
            { staticClass: "data-panel", attrs: { id: "customerNameLabel" } },
            [
              _c("fa", {
                staticClass: "data-panel__minimize cursor",
                attrs: {
                  icon: ["fas", _vm.isMinimized ? "caret-up" : "caret-down"],
                  title: _vm.isMinimized
                    ? "Expand layer list"
                    : "Minimize layer list",
                },
                on: { click: _vm.toggleMinimize },
              }),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-2", attrs: { "no-gutters": "" } },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "button",
                      {
                        staticClass: "change-region-btn",
                        attrs: { title: "Change Dataset" },
                        on: {
                          click: function ($event) {
                            return _vm.$bvModal.show("datasetSelection")
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "change-region-icon",
                            attrs: {
                              viewBox: "0 0 16 16",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("circle", {
                              attrs: {
                                cx: "8",
                                cy: "8",
                                r: "6.5",
                                stroke: "currentColor",
                                "stroke-width": "1.2",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M8 1.5C8 1.5 10.5 4 10.5 8S8 14.5 8 14.5M8 1.5C8 1.5 5.5 4 5.5 8S8 14.5 8 14.5M1.5 8h13",
                                stroke: "currentColor",
                                "stroke-width": "1.2",
                                "stroke-linecap": "round",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Change Dataset")]),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "layer-list-font" }, [
                    _vm._v(_vm._s(_vm.customerName)),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.selected
                ? _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "layer-list-font" }, [
                        _vm._v(
                          _vm._s(
                            _vm.selected.release_date_formatted +
                              " - " +
                              _vm.selected.extent_description
                          )
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selected
                ? _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "layer-list-font" }, [
                        _vm._v(_vm._s(_vm.selected.release_label)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentANSISelset
                ? _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "layer-list-font" }, [
                        _vm._v(_vm._s(_vm.currentANSISelset)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isUshrUser
                ? _c(
                    "div",
                    { staticClass: "ansi-side-col" },
                    [
                      _c("MMP_ANSI_Tools", {
                        ref: "ANSI_Tools",
                        attrs: {
                          ansiLayersButtonCtrl: _vm.ansiLayersButtonCtrl,
                          currentANSISelset: _vm.currentANSISelset,
                          currentANSIPartNumber: _vm.currentANSIPartNumber,
                          layerDefinition: _vm.layerDefinition,
                          map: _vm.map,
                          mmp_layersObj: _vm.mmp_layersObj,
                          otonomoFeatureTableSubcountry:
                            _vm.otonomoFeatureTableSubcountry,
                          selectedExtent: _vm.selectedExtent,
                          showStreetView: _vm.showStreetView,
                          currentAnsiSegment: _vm.currentAnsiSegment,
                          user: _vm.user,
                          otonomoEditedSubcountry: _vm.otonomoEditedSubcountry,
                          otonomoFilters: _vm.otonomoFilters,
                        },
                        on: {
                          getAnsiSelectedSelset: function ($event) {
                            return _vm.$emit("getAnsiSelectedSelset", $event)
                          },
                          getGSV: function ($event) {
                            return _vm.$emit("getGSV", $event)
                          },
                          getLegend: function ($event) {
                            return _vm.$emit("getLegend", $event)
                          },
                          initANSIFeatureTable: function ($event) {
                            return _vm.$emit("initANSIFeatureTable", $event)
                          },
                          initBiasedFeatureTable: function ($event) {
                            return _vm.$emit("initBiasedFeatureTable", $event)
                          },
                          initBIASEDReports: function ($event) {
                            return _vm.$emit("initBIASEDReports")
                          },
                          initANSIReports: function ($event) {
                            return _vm.$emit("initANSIReports")
                          },
                          initIntersectionReports: function ($event) {
                            return _vm.$emit("initIntersectionReports")
                          },
                          initResize: function ($event) {
                            return _vm.$emit("DLLChange")
                          },
                          otonomoToggledOff: function ($event) {
                            return _vm.$emit("otonomoToggledOff")
                          },
                          setOtonomoSubcountryNames: function ($event) {
                            return _vm.$emit(
                              "setOtonomoSubcountryNames",
                              $event
                            )
                          },
                          subcountryChanged: function ($event) {
                            return _vm.$emit("subcountryChanged")
                          },
                          toggleGSV: function ($event) {
                            return _vm.$emit("toggleGSV", $event)
                          },
                          updateAnsiLayerName: function ($event) {
                            return _vm.$emit("updateAnsiLayerName", $event)
                          },
                          updateANSISelset: function ($event) {
                            return _vm.$emit("updateANSISelset", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isMinimized,
              expression: "!isMinimized",
            },
          ],
          staticClass: "card-body-padding",
        },
        [
          _c(
            "div",
            { staticClass: "scroll-Container" },
            [
              _c("MMP_DLL", {
                ref: "ansiDLL",
                attrs: {
                  ansiLayersButtonCtrl: _vm.ansiLayersButtonCtrl,
                  ansiLayersToggle: _vm.ansiLayersToggle,
                  customerProjectId: _vm.customerProjectId,
                  filterClassesObj: _vm.filterClassesObj,
                  isUshrUser: _vm.isUshrUser,
                  isTabNav: false,
                  layerResponse: _vm.layerResponse,
                  map: _vm.map,
                  mmp_layersObj: _vm.mmp_layersObj,
                  otonomoSubcountry: _vm.otonomoSubcountry,
                  rules: _vm.rules,
                  selectAllControl: _vm.selectAllControl,
                  showANSILayers: _vm.showLayers,
                  spinnerManager: _vm.spinnerManager,
                  zoomEnded: _vm.zoomEnded,
                  zoomLevelCap: _vm.zoomLevelCap,
                  layerDefinition: _vm.layerDefinition,
                  showLidarPanel: _vm.showLidarPanel,
                  baseMapsOpen: _vm.baseMapsOpen,
                  extentsOpen: _vm.extentsOpen,
                },
                on: {
                  removeLayerListener: function ($event) {
                    return _vm.$emit("removeLayerListener")
                  },
                  basemapcollapse: function ($event) {
                    return _vm.$emit("basemapcollapse")
                  },
                  getFilterModal: function ($event) {
                    return _vm.getFilterModal($event.layer, $event.id)
                  },
                  getLegend: function ($event) {
                    return _vm.$emit("getLegend", $event)
                  },
                  getShowAttributes: function ($event) {
                    return _vm.$emit("getShowAttributes", $event)
                  },
                  layerButtonsChanged: function ($event) {
                    return _vm.$emit("layerButtonsChanged", $event)
                  },
                  loadAttributes: function ($event) {
                    return _vm.$emit("loadAttributes", $event)
                  },
                  toggleLayers: function ($event) {
                    return _vm.toggleANSILayers()
                  },
                  toggleLayerVisibility: function ($event) {
                    return _vm.$emit("toggleLayerVisibility", $event)
                  },
                  toTopOfList: function ($event) {
                    return _vm.$emit("toTopOfList", $event)
                  },
                  updateZoomEnded: function ($event) {
                    return _vm.$emit("updateZoomEnded", $event)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("MMP_LayerFilterModal", {
            attrs: {
              filter_layer: _vm.filter_layer,
              generateCQLObj: _vm.generateCQLObj,
              layerProperties: _vm.layerProperties,
              map: _vm.map,
              mmp_layersObj: _vm.mmp_layersObj,
              selectedElement: _vm.selectedElement,
              selsetCQL: `selset='${_vm.currentANSISelset}'`,
              user: _vm.user,
              zoomLevelCap: _vm.zoomLevelCap,
            },
            on: {
              filterClassesObjChanged: function ($event) {
                _vm.filterClassesObj = $event
              },
              rulesChanged: function ($event) {
                _vm.rules = $event
              },
              saveOtonomoRules: function ($event) {
                return _vm.$emit("saveOtonomoRules", $event)
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }